<template>
  <div>
    <input
      class="form__input form__input--date"
      type="text"

      disabled="disabled"
      :value="value"
    >
  </div>
</template>

<script>
// https://jsfiddle.net/Linusborg/ey3t0pk1/
import Pikaday from 'pikaday-time'
import 'pikaday-time/css/pikaday.css'

export default {
  name: 'datepicker',
  props: {
    value: {
      required: true
    },
    type: {
      type: String,
      required: true
    },
    options: {
      default: function () { return {} }
    },
    toggle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    opts() {
      return Object.assign({}, this.options)
    }
  },
  watch: {
    toggle(newValue) {
      newValue ? this.show() : this.hide()
    }
  },
  mounted() {
    var vm = this
    var opts = this.opts
    opts.field = this.$el
    if (this.type === 'datetime') {
      opts.showTime = true
      opts.format = 'MM/DD/YYYY HH:mm'
    } else {
      opts.showTime = false
      opts.format = 'MM/DD/YYYY'
    }

    // if user provided his own onSelect() callback option,
    // merge with ours into a new function
    if (opts.onSelect) {
      var old = opts.onSelect
      opts.onSelect = function() {
        old(...arguments)
        vm.change(this.toString())
      }
    } else {
      opts.onSelect = function() {
        vm.change(this.toString())
      }
    }

    // set up Pikaday
    this.pikaday = new Pikaday(opts)
  },
  beforeDestroy() {
    this.pikaday.destroy()
  },
  methods: {
    change(value) {
      this.$emit('input', value)
    },
    show() {
      this.pikaday.show()
    },
    hide() {
      this.pikaday.hide()
    }
  }
}
</script>



// WEBPACK FOOTER //
// DatePicker.vue?67abe155